// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-tasks-modal,
.assignment-manage-task-modal {
  width: 100%;
  padding: 32px 32px 0 !important;
}
.add-tasks-modal-overlay,
.assignment-manage-task-modal-overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: fixed;
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
  align-items: center;
  justify-content: center;
}
.add-tasks-modal .form-wrapper .select-label,
.assignment-manage-task-modal .form-wrapper .select-label {
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  line-height: 16px;
}
.add-tasks-modal .form-wrapper span::before,
.assignment-manage-task-modal .form-wrapper span::before {
  width: 18px;
  height: 18px;
}
.add-tasks-modal .form-wrapper span::after,
.assignment-manage-task-modal .form-wrapper span::after {
  width: 8px;
  height: 8px;
}
.add-tasks-modal .form-wrapper .form-label,
.assignment-manage-task-modal .form-wrapper .form-label {
  font-weight: 500;
}
.add-tasks-modal .form-wrapper .form-radio-group .form-control-radio:first-child,
.assignment-manage-task-modal .form-wrapper .form-radio-group .form-control-radio:first-child {
  min-width: 150px;
}
.add-tasks-modal .form-wrapper .form-radio-group .form-control-radio,
.assignment-manage-task-modal .form-wrapper .form-radio-group .form-control-radio {
  margin-bottom: 0;
  margin-top: 10px;
}
.add-tasks-modal .form-wrapper .form-control-select,
.assignment-manage-task-modal .form-wrapper .form-control-select {
  margin-top: 8px;
}
.add-tasks-modal .form-wrapper .form-control-select .react-select-multi__multi-value,
.assignment-manage-task-modal .form-wrapper .form-control-select .react-select-multi__multi-value {
  display: none;
}
.add-tasks-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option,
.assignment-manage-task-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option {
  padding-top: 4px;
  padding-bottom: 4px;
}
.add-tasks-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option::before,
.assignment-manage-task-modal .form-wrapper .form-control-select.multi-select-days .react-select-multi__option::before {
  width: 18px;
  height: 18px;
  top: 6px;
}
.add-tasks-modal .form-wrapper .period-type-wrapper,
.assignment-manage-task-modal .form-wrapper .period-type-wrapper {
  gap: 24px;
}
.add-tasks-modal .form-wrapper .selected-shifts-list,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list {
  margin-top: 16px;
  display: flex;
  gap: 20px;
}
.add-tasks-modal .form-wrapper .selected-shifts-list .selected-shift-item,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list .selected-shift-item {
  display: flex;
  gap: 10px;
}
.add-tasks-modal .form-wrapper .selected-shifts-list .selected-shift-item p,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list .selected-shift-item p {
  line-height: 20px;
}
.add-tasks-modal .form-wrapper .selected-shifts-list .selected-shift-item:hover,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list .selected-shift-item:hover {
  color: #7f56d9;
}
.add-tasks-modal .form-wrapper .selected-shifts-list .selected-shift-item svg,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list .selected-shift-item svg {
  cursor: pointer;
}
.add-tasks-modal .form-wrapper .selected-shifts-list .selected-shift-item svg:hover,
.assignment-manage-task-modal .form-wrapper .selected-shifts-list .selected-shift-item svg:hover {
  opacity: 0.7;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list {
  display: flex;
  gap: 20px;
  margin-top: 16px;
  flex-wrap: wrap;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item {
  display: flex;
  gap: 10px;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item p,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item p {
  line-height: 20px;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item:hover,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item:hover {
  color: #7f56d9;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg {
  cursor: pointer;
}
.add-tasks-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg:hover,
.assignment-manage-task-modal .form-wrapper .selected-weekdays-list .selected-weekdays-item svg:hover {
  opacity: 0.7;
}
.add-tasks-modal .form-wrapper .react-select-multi__menu,
.assignment-manage-task-modal .form-wrapper .react-select-multi__menu {
  width: 100%;
  max-width: unset;
  min-width: unset;
}
.add-tasks-modal .form-wrapper .selected-tasks-list,
.assignment-manage-task-modal .form-wrapper .selected-tasks-list {
  display: block;
  margin-top: 16px;
}
.add-tasks-modal .form-wrapper .selected-tasks-item,
.assignment-manage-task-modal .form-wrapper .selected-tasks-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}
.add-tasks-modal .form-wrapper .selected-tasks-item p,
.assignment-manage-task-modal .form-wrapper .selected-tasks-item p {
  width: fit-content;
}
.add-tasks-modal .form-wrapper .selected-tasks-item:hover,
.assignment-manage-task-modal .form-wrapper .selected-tasks-item:hover {
  color: #7f56d9;
}
.add-tasks-modal .form-wrapper .selected-tasks-item svg,
.assignment-manage-task-modal .form-wrapper .selected-tasks-item svg {
  cursor: pointer;
}
.add-tasks-modal .form-wrapper .selected-tasks-item svg:hover,
.assignment-manage-task-modal .form-wrapper .selected-tasks-item svg:hover {
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/pages/cna/assignments/unit/components/manage-task-modal/styles.scss"],"names":[],"mappings":"AAAA;;EAEE,WAAA;EACA,+BAAA;AACF;AACE;;EACE,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;AAEI;;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AACN;AAEI;;EACE,WAAA;EACA,YAAA;AACN;AAEI;;EACE,UAAA;EACA,WAAA;AACN;AAEI;;EACE,gBAAA;AACN;AAGM;;EACE,gBAAA;AAAR;AAGM;;EACE,gBAAA;EACA,gBAAA;AAAR;AAII;;EACE,eAAA;AADN;AAGM;;EACE,aAAA;AAAR;AAIQ;;EACE,gBAAA;EACA,mBAAA;AADV;AAGU;;EACE,WAAA;EACA,YAAA;EACA,QAAA;AAAZ;AAMI;;EACE,SAAA;AAHN;AAMI;;EACE,gBAAA;EACA,aAAA;EACA,SAAA;AAHN;AAKM;;EACE,aAAA;EACA,SAAA;AAFR;AAIQ;;EACE,iBAAA;AADV;AAIQ;;EACE,cAAA;AADV;AAGQ;;EACE,eAAA;AAAV;AAEU;;EACE,YAAA;AACZ;AAKI;;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AAFN;AAIM;;EACE,aAAA;EACA,SAAA;AADR;AAGQ;;EACE,iBAAA;AAAV;AAGQ;;EACE,cAAA;AAAV;AAEQ;;EACE,eAAA;AACV;AACU;;EACE,YAAA;AAEZ;AAII;;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AADN;AAKM;;EACE,cAAA;EACA,gBAAA;AAFR;AAKM;;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAFR;AAIQ;;EACE,kBAAA;AADV;AAIQ;;EACE,cAAA;AADV;AAGQ;;EACE,eAAA;AAAV;AAEU;;EACE,YAAA;AACZ","sourcesContent":[".add-tasks-modal,\n.assignment-manage-task-modal {\n  width: 100%;\n  padding: 32px 32px 0 !important;\n\n  &-overlay {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    position: fixed;\n    display: flex;\n    padding-top: 24px;\n    padding-bottom: 24px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .form-wrapper {\n    .select-label {\n      font-size: 14px;\n      font-weight: 500;\n      display: inline-block;\n      line-height: 16px;\n    }\n\n    span::before {\n      width: 18px;\n      height: 18px;\n    }\n\n    span::after {\n      width: 8px;\n      height: 8px;\n    }\n\n    .form-label {\n      font-weight: 500;\n    }\n\n    .form-radio-group {\n      .form-control-radio:first-child {\n        min-width: 150px;\n      }\n\n      .form-control-radio {\n        margin-bottom: 0;\n        margin-top: 10px;\n      }\n    }\n\n    .form-control-select {\n      margin-top: 8px;\n\n      .react-select-multi__multi-value {\n        display: none;\n      }\n\n      &.multi-select-days {\n        .react-select-multi__option {\n          padding-top: 4px;\n          padding-bottom: 4px;\n\n          &::before {\n            width: 18px;\n            height: 18px;\n            top: 6px;\n          }\n        }\n      }\n    }\n\n    .period-type-wrapper {\n      gap: 24px;\n    }\n\n    .selected-shifts-list {\n      margin-top: 16px;\n      display: flex;\n      gap: 20px;\n\n      .selected-shift-item {\n        display: flex;\n        gap: 10px;\n\n        p {\n          line-height: 20px;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n\n    .selected-weekdays-list {\n      display: flex;\n      gap: 20px;\n      margin-top: 16px;\n      flex-wrap: wrap;\n\n      .selected-weekdays-item {\n        display: flex;\n        gap: 10px;\n\n        p {\n          line-height: 20px;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n\n    .react-select-multi__menu {\n      width: 100%;\n      max-width: unset;\n      min-width: unset;\n    }\n\n    .selected-tasks {\n      &-list {\n        display: block;\n        margin-top: 16px;\n      }\n\n      &-item {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        margin: 10px 0;\n\n        p {\n          width: fit-content;\n        }\n\n        &:hover {\n          color: #7f56d9;\n        }\n        svg {\n          cursor: pointer;\n\n          &:hover {\n            opacity: 0.7;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
